import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function MedicalShowcase() {
  return (
    <section className="relative bg-charcoal-deep overflow-hidden">
      <div className="grid lg:grid-cols-2">
        <ScrollReveal direction="left" className="relative aspect-[4/3] lg:aspect-auto">
          <img
            src="/images/heroes/hero-9-medical-office.webp"
            alt="Medical office cleaning"
            className="w-full h-full object-cover"
          />
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(135deg, transparent 50%, rgba(15,15,30,.9) 100%)' }}
          />
        </ScrollReveal>

        <ScrollReveal direction="right" className="p-10 lg:p-20 flex flex-col justify-center relative">
          <div className="absolute top-10 right-10 font-display text-[10rem] text-white/[0.03] leading-none hidden lg:block">06</div>
          <div className="text-electric font-display tracking-[0.4em] text-xs mb-5">// INDUSTRY AGNOSTIC</div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mb-8">
            WE CLEAN <span className="text-thunder">EVERY</span> INDUSTRY.
          </h2>
          <p className="text-white/70 text-lg mb-8 leading-relaxed">
            Medical offices. Law firms. Retail. Warehouses. Restaurants. Fitness studios.
            If it has a floor and walls, we've got a crew for it.
          </p>
          <div className="grid grid-cols-2 gap-4">
            {['Medical / Clinical', 'Professional Services', 'Retail & Hospitality', 'Post-Construction'].map((t) => (
              <div key={t} className="border-l-2 border-electric pl-4 py-1">
                <div className="font-display tracking-wider text-white text-sm">{t}</div>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
